var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCard = function SvgCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.893 3.5H2.107a.599.599 0 0 0-.607.59v11.82c0 .326.271.59.607.59h15.786a.599.599 0 0 0 .607-.59V4.09a.599.599 0 0 0-.607-.59ZM2.866 4.83h14.268v2.215H2.866V4.83Zm14.268 10.34H2.866v-6.5h14.268v6.5Zm-4.497-1.181h3.13a.15.15 0 0 0 .153-.148v-1.33a.15.15 0 0 0-.152-.147h-3.13a.15.15 0 0 0-.152.147v1.33a.15.15 0 0 0 .151.148Z",
    fill: "#999"
  })));
};
export default SvgCard;